import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../shared/Logo';

const signInUri = () => {
  const queryParams = new URLSearchParams();
  queryParams.set('redirect_uri', `${window.location.origin}/set-token`);
  queryParams.set('return_to', '/');

  return `${process.env.REACT_APP_OAUTH_REDIRECT_URI}?${queryParams}`;
}

class LandingPage extends React.Component {
  render() {
    return (
      <div className="gloabal-wrapper app-intro">
        <header className="main-header">
          <Logo />
          <nav>
            <ul>
              <li className="user-box">
                <Link to={signInUri()} target="_self" title="Login" className="button">Login</Link>
              </li>
            </ul>
          </nav>
        </header>
        <main className="main-wrapper">
          <section>
            <div>
              <h1>Staff Scheduling Application</h1>
            </div>
          </section>
        </main>
      </div>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/landing/LandingPage.js